module.exports = __webpack_public_path__ + "static/media/dutch.a9ff6971.svg";